import VisibilityOffOutlined from '@mui/icons-material/VisibilityOffOutlined'
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { useState } from 'react'
import { TextInputProps } from '../../types/form.types'

export const PasswordInput = ({
  register,
  errors,
  label,
  name,
  sx
}: TextInputProps) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <TextField
      fullWidth
      label={label}
      variant='filled'
      sx={[
        {
          '& .MuiInputBase-root': {
            backgroundColor: 'rgba(255, 255, 255, 0.09)',
            '&.Mui-error': {
              backgroundColor: 'rgba(255, 255, 255, 0.09)'
            },
            '&.Mui-focused': {
              backgroundColor: 'rgba(255, 255, 255, 0.09)'
            }
          }
        },
        sx
      ]}
      type={showPassword ? 'text' : 'password'}
      {...register(name, { required: 'Password is required' })}
      error={!!errors[name]}
      helperText={errors[name]?.message?.toString()}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge='end'
                sx={{ color: 'text.secondary' }}
              >
                {showPassword ? (
                  <VisibilityOutlined />
                ) : (
                  <VisibilityOffOutlined />
                )}
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  )
}
